import moment from "moment";

export const formatDocumentDate = (date) => {
  if (!date) return "-";

  if (typeof date === "string") {
    const formats = [
      "YYYY-MM-DD",
      "DD-MM-YYYY",
      "DD/MM/YYYY",
      "YYYY-MM-DD HH:mm",
      "YYYY-MM-DD HH:mm:ss",
      "DD-MM-YYYY HH:mm",
      "DD-MM-YYYY HH:mm:ss",
      "DD/MM/YYYY HH:mm",
      "DD/MM/YYYY HH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss.SSS",
      "YYYY-MM-DDTHH:mm:ss.SSSZ",
      moment.ISO_8601
    ];
    const momentDate = moment(date, formats, true);
    if (momentDate.isValid()) {
      return momentDate.format("DD/MM/YYYY");
    }
    const fallbackDate = moment(date);
    if (fallbackDate.isValid()) {
      return fallbackDate.format("DD/MM/YYYY");
    }
    return "-";
  }

  if (Array.isArray(date) && date.length >= 3) {
    return moment(
      new Date(date[0], date[1] - 1, date[2])
    ).format("DD/MM/YYYY");
  }

  return "-";
};

export const formatReviewDate = (reviewTime) => {
  if (!reviewTime || !Array.isArray(reviewTime) || reviewTime.length < 3) {
    return "-";
  }

  return moment(
    new Date(reviewTime[0], reviewTime[1] - 1, reviewTime[2])
  ).format("DD/MM/YYYY");
};

export const formatDocumentType = (type) => {
  if (!type) return "-";
  return type.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
};

export const getReviewerName = (reviewedBy) => {
  if (!reviewedBy) return "-";
  if (reviewedBy.firstName || reviewedBy.lastName) {
    return `${reviewedBy.firstName || ""} ${reviewedBy.lastName || ""}`.trim();
  }
  return "-";
};

export const formatPriority = (priority) => {
  const priorities = {
    "-1": { label: "Unknown", icon: "priority-medium", color: "#26252C" },
    0: { label: "Low", icon: "priority-down", color: "#006546" },
    1: { label: "Normal", icon: "priority-medium", color: "#26252C" },
    2: { label: "High", icon: "priority-up", color: "#B70000" },
  };

  if (priority === null || priority === undefined) {
    return { label: "Unknown", icon: "priority-medium", color: "#26252C" };
  }

  return priorities[priority] || { label: "Unknown", icon: "priority-medium", color: "#26252C" };
};

export const formatFileSize = (bytes) => {
  if (!bytes) return "-";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatStatusLabel = (status) => {
  if (!status) return "Unknown";
  return status
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const getStatusDisplay = (status) => {
  if (!status) return { label: "Unknown", variant: "unknown" };

  const upperStatus = status.toUpperCase();

  const variantMap = {
    NEW: "new",
    IN_REVIEW: "inReview",
    REVIEWED: "reviewed",
    CLOSED: "closed",
    UPLOADED: "uploaded",
    SYSTEM_GENERATED: "systemGenerated",
  };

  const variant = variantMap[upperStatus] || "unknown";
  const label = formatStatusLabel(upperStatus);

  return { label, variant };
};
